import React, { createContext, useContext, useReducer } from 'react';
import { IPublicationDetailState, initialState, PublicationDetailReducer } from './publication-detail-reducer';

const PublicationDetailContext = createContext<IPublicationDetailState | undefined>(undefined);
const PublicationDetailDispatchContext = createContext<React.Dispatch<any> | undefined>(undefined);

export function PublicationDetailProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(PublicationDetailReducer, initialState);

    return (
        <PublicationDetailContext.Provider value={state}>
            <PublicationDetailDispatchContext.Provider value={dispatch}>
                {children}
            </PublicationDetailDispatchContext.Provider>
        </PublicationDetailContext.Provider>
    );
}

export function usePublicationDetailState() {
    const context = useContext(PublicationDetailContext);
    if (context === undefined) {
        throw new Error('usePublicationDetailState must be used within a PublicationDetailProvider');
    }
    return context;
}

export function usePublicationDetailDispatch() {
    const context = useContext(PublicationDetailDispatchContext);
    if (context === undefined) {
        throw new Error('usePublicationDetailDispatch must be used within a PublicationDetailProvider');
    }
    return context;
}
